const base64ToFile = (base64Data, fileName = 'document.pdf') => {
  let mime = 'application/pdf';

  if (base64Data?.includes('data:')) {
    const arr = base64Data.split(',');
    const match = arr[0].match(/:(.*?);/);
    if (match) mime = match[1];
    base64Data = arr[1];
  }

  const byteString = atob(base64Data);
  const byteArray = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new File([byteArray], fileName, { type: mime });
};

const getFileNameFromUrl = (url) => {
  return url.split('/').pop().split('?')[0];
};

const getFileTypeFromUrl = (url) => {
  const extension = url.split('.').pop().split('?')[0];
  return `application/${extension}`;
};

const getFileSizeFromUrl = async (url) => {
  const response = await fetch(url, { method: 'HEAD' });
  const size = response.headers.get('content-length');
  return size ? (size / 1024).toFixed(2) + ' KB' : 'Unknown';
};

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export {getFileTypeFromUrl, getFileNameFromUrl, base64ToFile, getFileSizeFromUrl, blobToBase64};